import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scroll, CheckCircle2 } from "lucide-react";

const DECALOGO = [
  "Me esforzaré en crear una excelente alianza terapéutica con mis pacientes.",
  "Respetaré las decisiones de mis pacientes y sus familiares una vez que estén bien informados.",
  "Entenderé que no soy dueño de los pacientes. Les facilitaré que consigan una segunda opinión.",
  "Seré cauto en mis opiniones, siempre evitando hacer juicios prematuros o sin evidencias.",
  "Aprenderé lo bueno de mis colegas médicos.",
  "Aprenderé a trabajar en equipo.",
  "Me esforzaré en llevar expedientes completos, archivados con orden, asegurando que nadie tenga acceso a ellos. Realizaré buenas evaluaciones, historias clínicas objetivas, integrando síndromes clínicos, para diagnósticos acertados basados en evidencias y tratamientos congruentes y correctos, evitando siempre medicamentos innecesarios.",
  "Guardaré completa discreción de las confidencias de mis enfermos.",
  "Me integraré a grupos, sociedades, asociaciones, colegios o consejos médicos que promuevan y estimulen la superación académica. La formación médica nunca termina.",
  "Viviré dignamente de honorarios justos.",
];

export default function Decalogo() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-cyan-700 transition mb-8 text-sm">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-50 text-cyan-700 text-sm font-medium mb-4">
          <Scroll size={16} /> Decálogo Médico
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Mi Decálogo Médico
        </h1>
        <p className="text-xl text-slate-600">Principios que guían mi práctica profesional</p>
      </div>

      <div className="space-y-4">
        {DECALOGO.map((item, i) => (
          <div key={i} className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md hover:border-cyan-200 transition-all">
            <div className="flex items-start gap-5">
              <div className="w-12 h-12 flex-shrink-0 rounded-2xl bg-gradient-to-br from-cyan-600 to-teal-600 text-white flex items-center justify-center font-bold text-xl shadow-md group-hover:scale-110 transition-transform">
                {i + 1}
              </div>
              <div className="flex-1 pt-1.5">
                <p className="text-slate-700 leading-relaxed text-base md:text-lg">{item}</p>
              </div>
              <CheckCircle2 className="text-emerald-500 flex-shrink-0 mt-1.5 hidden sm:block" size={22} />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center bg-gradient-to-br from-cyan-600 to-teal-700 rounded-2xl p-8 text-white">
        <p className="italic text-lg mb-2">"La formación médica nunca termina"</p>
        <p className="text-cyan-100 text-sm">Dr. César S. Martínez Maldonado · 1986</p>
      </div>
    </div>
  );
}
